import React, { Component } from "react";
import Layout from "layouts/DashboardManage";
import { Link } from "react-router-dom";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import classNames from "classnames";
import ReactTooltip from "react-tooltip";
import Pagination from "components/Pagination";
import ManageDataTable from "components/ManageDataTable";
import { SpinnerRainbow } from "components/Spinner";
import ManageFilters from "../Forms/Elements/SearchManageComponents";
import {
  getAllClients,
  deleteClient,
  resetPayload,
  DELETE_CLIENT
} from "store/actions/clientAction";
import { MANAGE_TEAMS, MANAGE_WORKFLOWS } from "helpers/role";
import Notification, { notifyApiError } from "components/Notification";
import Translate from "helpers/Translate";
import NoData from "components/NoData";

export class Client extends Component {
  state = {
    showDeleteConfirm: false
  };

  componentDidMount() {
    this.props.getAllClients({});
  }

  componentDidUpdate(prevProps) {
    if (prevProps.error !== this.props.error) {
      notifyApiError(this.props.error);
    }

    if (this.props.deleteStatus === 200) {
      Notification.success(Translate({ id: "data_deleted_successfully" }));
      this.props.resetPayload(DELETE_CLIENT);
      this.props.getAllClients({ page: 1 });
    }
  }

  handleDelete = (e, item) => {
    e.preventDefault();
    const id = e.currentTarget.id || item.id;
    Notification.confirm(
      Translate({ id: "sure_to_delete", values: [item.name] }),
      {
        onOk: () => {
          this.props.deleteClient(id);
        }
      }
    );
  };

  onPageChange = data => {
    let selectedPage = parseInt(data.selected) + 1;
    this.props.getAllClients({ page: selectedPage });
  };

  hasData = () => {
    return (
      !this.props.isLoading &&
      this.props.clients &&
      this.props.clients.data &&
      this.props.clients.data.length > 0
    );
  };

  render() {
    return (
      <Layout>
        <div className="manage">
          <Link className="back mb-20" to="/manage">
            <i className="fas fa-long-arrow-alt-left"></i>{" "}
            {Translate({ id: "back_to_manage_dashboard" })}
          </Link>
          <div className="manage-page-heading">
            <span className="manage-page-icon tone-rose" aria-hidden="true">
              <i className="fas fa-building"></i>
            </span>
            <div className="manage-page-heading__text">
              <h1 className="title">{Translate({ id: "manage_clients" })}</h1>
              <p className="manage-page-subtitle">
                {Translate({ id: "manage_clients_description" })}
              </p>
            </div>
          </div>
          <div className="manage-list-actions">
            <div className="search-client-data">
              <ManageFilters
                id="search-client"
                getAllData={getAllClients}
                placeholder="Search Client"
                propertyField="name"
                propertyValue="name"
              />
            </div>
            <Link
              className="btn btn-primary btn-add-manage"
              to="/manage/clients/add"
              data-test="add_button"
            >
              <i className="fas fa-plus mr-10"></i>
              {Translate({ id: "add_client" })}
            </Link>
          </div>

          {this.props.isLoading && <SpinnerRainbow />}

          {!this.props.isLoading && (
            <ManageDataTable
              footer={
                this.hasData() ? (
                  <Pagination
                    onPageChange={this.onPageChange}
                    data={this.props.clients && this.props.clients.meta}
                  />
                ) : null
              }
            >
              <table>
                <thead>
                  <tr>
                    <th className="left">{Translate({ id: "name" })} </th>
                    <th>{Translate({ id: "total_character_count" })}</th>
                    <th className="action-col">
                      {Translate({ id: "action" })}
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {this.hasData() &&
                    this.props.clients.data.map(item => (
                      <tr key={item.id}>
                        <td>
                          <ReactTooltip />
                          {item.name}
                        </td>
                        <td>{item.total_character_count}</td>
                        <td className="action-col">
                          <div className="manage-data-table-actions">
                            <Link
                              className="action-btn action-edit"
                              data-tip={Translate({ id: "edit" })}
                              to={`/manage/clients/edit/${item.id}`}
                            >
                              <i className="fas fa-pencil-alt"></i>
                            </Link>
                            <button
                              type="button"
                              className="action-btn action-delete"
                              data-tip={Translate({ id: "delete" })}
                              id={item.id}
                              onClick={e => this.handleDelete(e, item)}
                            >
                              <i className="fas fa-trash-alt" id={item.id}></i>
                            </button>
                            <Link
                              className={classNames(
                                "action-btn action-secondary",
                                {
                                  hide: ![]
                                    .concat(this.props.permissions)
                                    .includes(MANAGE_TEAMS)
                                }
                              )}
                              data-tip={Translate({ id: "team" })}
                              to={`/manage/clients/${item.id}/teams/manage`}
                            >
                              <i className="fas fa-users"></i>
                            </Link>
                            <Link
                              className={classNames(
                                "action-btn action-secondary",
                                {
                                  hide: ![]
                                    .concat(this.props.permissions)
                                    .includes(MANAGE_WORKFLOWS)
                                }
                              )}
                              data-tip={Translate({ id: "workflows" })}
                              to={`/manage/clients/${item.id}/workflows/manage`}
                            >
                              <i className="fas fa-wave-square"></i>
                            </Link>
                          </div>
                        </td>
                      </tr>
                    ))}

                  {!this.hasData() && (
                    <tr>
                      <td colSpan="100">
                        <NoData />
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </ManageDataTable>
          )}
        </div>
      </Layout>
    );
  }
}

Client.propTypes = {
  getAllClients: PropTypes.func.isRequired,
  clients: PropTypes.object,
  isLoading: PropTypes.bool,
  deleteStatus: PropTypes.number,
  error: PropTypes.object
};

const mapStateToProps = state => {
  return {
    permissions: state.role.getPermissions,
    clients: state.client.getAllClients,
    isLoading: state.client.isLoadingClient,
    deleteStatus: state.client.deleteClientStatus,
    error: state.client.errorClient
  };
};

export default connect(mapStateToProps, {
  getAllClients,
  deleteClient,
  resetPayload
})(Client);
